import React, { PropTypes } from 'react';
import NumberFormat from 'react-number-format';

const DEFAULT_SYMBOL = '$';

export function money (props) {
  const {
    options,
    value,
    onChange,
    required,
  } = props;

  return (
    <Money
      required={required}
      value={value}
      onChange={onChange}
      {...options}
    />

  );
}

class Money extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const {
      name,
      value,
      onChange,
      currency,
      outputType,
      symbol = DEFAULT_SYMBOL,
      required,
      className,
    } = this.props

    let newValue;
    if(value == 0 || !value){
      newValue = ''
    } else {
      newValue = value
    }

    return (
      <div className={`number-input money form-input ${className}`}>
        <NumberFormat
          value={newValue}
          allowNegative={false}
          onChange={(event)=>{
            let value = event.target.value || '';
            onChange(value.replace('$', ''));
          }}
          placeholder='$0'
          required={required}
          decimalScale={2}
          thousandSeparator={false}
          className='form-control'
          prefix={symbol} />
        <div className='unit-marker'>{currency}</div>
      </div>
    );

  }
}

export default Money;



// WEBPACK FOOTER //
// ./src/components/UI/Form/Fields/Money.js